import FeedbackTriangleIcon from 'src/assets/icons/FeedbackTriangleIcon';
import LocationIcon from 'src/assets/icons/Location';
import {
  AgentActivityLevel,
  ColorMap,
  FilterTypes,
  IFilterMap,
  IFilterPayload,
  LOCATION_TYPE_FILTERS
} from './LiveLocationTrackerInterfaces';
import styles from '../index.module.scss';
import FolderIcon from 'src/assets/images/icons/FolderIcon';
import AgentLocationIcon from 'src/assets/images/icons/AgentLocationIcon';
import ChatBubble from 'src/assets/images/icons/ChatBubble';
import ChatBubbleExclamation from 'src/assets/images/icons/ChatBubbleExclamation';

export const FilterMap: IFilterMap = {
  [FilterTypes.AGENCY]: {
    placeholder: 'Filter agency name',
    nextFilter: FilterTypes.TEAM_LEAD
  },
  [FilterTypes.TEAM_LEAD]: {
    placeholder: 'Filter team lead',
    dependentOnFilter: FilterTypes.AGENCY
  }
};

export const PinColorMapping: Record<string, string> = {
  [AgentActivityLevel.HIGH]: 'red',
  [AgentActivityLevel.MEDIUM]: 'yellow',
  [AgentActivityLevel.LOW]: 'green'
};

export const AGENT_LIVE_LOCATION = 'AGENT_LIVE_LOCATION';

export const MarkerInfoList = [
  {
    color: '#CE0F18',
    label: 'Inactive'
  },
  {
    color: '#FFD427',
    label: 'At risk'
  },
  {
    color: '#03631E',
    label: 'Active'
  }
];

export const DEFAULT_FILTER_PAYLOAD: IFilterPayload = {
  type: FilterTypes.AGENCY,
  agencyCodes: []
};

export const locationsPinFilters = [
  {
    icon: <LocationIcon />,
    label: 'All',
    value: LOCATION_TYPE_FILTERS.ALL
  },
  {
    icon: <FolderIcon />,
    label: 'Cases',
    value: LOCATION_TYPE_FILTERS.CASES
  },
  {
    icon: <AgentLocationIcon />,
    label: 'Agent',
    value: LOCATION_TYPE_FILTERS.AGENT
  },
  {
    icon: <ChatBubble />,
    label: 'Genuine feedback',
    value: LOCATION_TYPE_FILTERS.GENUINE_FEEDBACK
  },
  {
    icon: <ChatBubbleExclamation />,
    label: 'Suspicious feedback',
    value: LOCATION_TYPE_FILTERS.SUSPICIOUS_FEEDBACK
  }
];

export const DEFAULT_TEXT = '--';

export const MIN_CHAR_LENGTH_FOR_TOOLTIP = 20;

export enum LIVE_LOCATION_SOURCE {
  EXTERNAL_SENSEI = 'external_sensei',
  PERFORMANCE_DASHBOARD = 'performance_dashboard'
}

export const LIVE_LOCATION_TRACKER_PAGE = 'Live_location_tracker';

export enum MapViewTabs {
  ALLOCATION = 'allocation_view',
  LIVE_LOCATION_TRACKER = 'live_location'
}

export const MAP_VIEW_TABS = [
  {
    title: 'Allocation view',
    id: 'allocation_view'
  },
  {
    title: 'Agent location view',
    id: 'live_location'
  }
];

export const colorMap: ColorMap = {
  yellow: {
    shade1: '#E3B80C',
    shade2: '#FDF0BC',
    shade3: '#FFD427',
    textColor: 'var(--greyscale-content-3)'
  },
  red: {
    shade1: '#A1070D',
    shade2: '#E56C67',
    shade3: '#CE0F18',
    textColor: 'var(--text-primary)'
  },
  green: {
    shade1: '#013C12',
    shade2: '#43B062',
    shade3: '#03631E',
    textColor: 'var(--text-primary)'
  }
};
